import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { all_routes } from "../../router/all_routes";
import ReactApexChart from "react-apexcharts";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { fetchAllProjects } from "../../../core/data/redux/projects/project/projectAction";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { fetchAllProjectReport } from "../../../core/data/redux/reports/project_report/project.Action";
import {
  exportToCSV,
  exportToExcel,
} from "../../../core/common/GlobalFunctions/exportTableData";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";

interface ProjectReportProps {
  showOnlyTable?: boolean;
}

const ProjectReport: React.FC<ProjectReportProps> = ({showOnlyTable}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [count, setcount] = useState<any>(null);
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [selectedSort, setSelectedSort] = useState<any>("");
  const { projectsData } = useSelector((state: any) => state.project.projects);
  const [tableKey, setTableKey] = useState(0);

  const getPercent = (value: number | string, total: number | string) =>
    total ? Math.round((+value / +total) * 100) : 0;

  useEffect(() => {
    dispatch(fetchAllProjects());
    dispatch(fetchAllProjectReport()).then((res) => {
      setcount(res.payload.data);
    });
  }, []);

  const filtereddata = useMemo(() => {
    const filters =
      selectedStatus && selectedStatus !== "All"
        ? { priority: selectedStatus }
        : {};
    return filterData(
      projectsData,
      filters,
      "created_at",
      "created_at",
      selectedSort
    );
  }, [projectsData, selectedStatus, selectedSort]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [dispatch, projectsData, selectedSort, selectedStatus]);

  const data = projectsData ? projectsData : [];


  function filterProjectData(data: any[]) {
    return data.map(project => ({
      projectName: project.project_name || "N/A",
      startDate: new Date(project.start_date).toLocaleDateString(),
      endDate: new Date(project.end_date).toLocaleDateString(),
      priority: project.priority || "N/A",
      projectValue: project.project_value || "0.00",
      projectProgress: project.project_progress || "N/A",
      projectManager: project.project_manager_name || "N/A",
      teamLead: project.team_lead_name || "N/A",
      employeeNames: project.employee_names?.join(", ") || "N/A"
    }));
  }

  const data2 = filterProjectData(data)

  const columns = [
    {
      title: "Project ID",
      dataIndex: "project_id",
      sorter: (a: any, b: any) => a.project_id.length - b.project_id.length,
    },
    {
      title: "Project Name",
      dataIndex: "project_name",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          <h6 className="fw-medium">
            <Link to="#">{text}</Link>
          </h6>
        </div>
      ),
      sorter: (a: any, b: any) => a.project_name.length - b.project_name.length,
    },
    {
      title: "Leader",
      dataIndex: "team_lead_name",
      render: (text: String, record: any) => (
        <div className="d-flex align-items-center file-name-icon">
          {/* <Link to="#" className="avatar avatar-md border avatar-rounded">
                        <ImageWithBasePath src={record.employee_pictures} className="img-fluid" alt="img" />
                    </Link> */}
          <div className="ms-2">
            <h6 className="fw-normal fs-14 text-gray-5">
              {record.team_lead_name}
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) =>
        a.team_lead_name.length - b.team_lead_name.length,
    },
    {
      title: "Manager",
      dataIndex: "project_manager_name",
      render: (text: String, record: any) => (
        <div className="avatar-list-stacked avatar-group-sm">
          <div className="ms-2">
            <h6 className="fw-normal fs-14 text-gray-5">
              {record.project_manager_name}
            </h6>
          </div>
        </div>
      ),
      sorter: (a: any, b: any) =>
        a.project_manager_name.length - b.project_manager_name.length,
    },
    {
      title: "Deadline",
      dataIndex: "end_date",
      sorter: (a: any, b: any) => new Date(a.end_date).getTime() - new Date(b.end_date).getTime(),
      render: (text: string) => text ? text.split("T")[0] : "",
    },
    {
      title: "Priority",
      dataIndex: "priority",
      render: (text: String, record: any) => (
        <span
          className={`badge  ${text === "Low"
              ? "badge-success-transparent"
              : text === "Medium"
                ? "badge-warning-transparent"
                : "badge-danger-transparent"
            }`}
        >
          <i className="ti ti-point-filled me-1"></i>
          {text}
        </span>
      ),
      sorter: (a: any, b: any) => a.priority.length - b.priority.length,
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text: String, record: any) => (
        <span
          className={`badge  d-inline-flex align-items-center badge-xs ${text === "active" ? "badge-success" : "badge-danger"
            }`}
        >
          <i className="ti ti-point-filled me-1" />
          {text}
        </span>
      ),
      sorter: (a: any, b: any) => a.status.length - b.status.length,
    },
  ];

  useEffect(() => {
    if (count && count.length > 0) {
      const {
        completed_projects,
        on_hold_projects,
        pending_projects,
        inprogress_projects,
      } = count[0];

      setprojectchart((prev: any) => ({
        ...prev,
        series: [
          Number(completed_projects || 0),
          Number(on_hold_projects || 0),
          Number(pending_projects || 0),
          Number(inprogress_projects || 0),
        ],
      }));
    }
  }, [count, dispatch]);



  //New Chart
  const [projectchart, setprojectchart] = useState<any>({
    series: [0, 0, 0, 0],
    chart: {
      width: 280,
      type: "pie",
    },
    labels: ["Completed", "On Hold", "Pending", "In Progress"],
    colors: ["#03C95A", "#AB47BC", "#0DCAF0", "#FFC107"],
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    tooltip: {
      y: {
        formatter: function (value: string, { seriesIndex }: any) {
          return "Value: " + value;
        },
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  });

  if (showOnlyTable) {
  return (
      <Table
       key={tableKey}
       dataSource={filtereddata}
       columns={columns}
       Selection={false}
      />
  );
}
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Project Report</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">HR</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Project Report
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(data2, "Project_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(data2, "Project_report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            {/* Total Exponses */}
            <div className="col-lg-6 col-md-6 d-flex">
              <div className="row flex-fill">
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body ">
                      <div>
                        <div className="mb-2">
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Total Projects
                          </span>
                          <h5>{count?.[0].total_projects}</h5>
                        </div>
                        <div
                          className="progress"
                          role="progressbar"
                          aria-label="Basic example"
                          aria-valuenow={count?.[0].total_projects}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ width: "100%", height: 5 }}
                        >
                          <div
                            className="progress-bar bg-pink"
                            style={{ width: `${count?.[0].total_projects}%` }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body ">
                      <div>
                        <div className="mb-2">
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Completed Projects
                          </span>
                          <h5>{count ? count?.[0].completed_projects : 0}</h5>
                        </div>
                        <div
                          className="progress"
                          role="progressbar"
                          aria-label="Basic example"
                          aria-valuenow={count?.[0].completed_projects}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ width: "100%", height: 5 }}
                        >
                          <div
                            className="progress-bar bg-success"
                            style={{ width: count?.[0].completed_projects }}
                          />
                        </div>
                      </div>
                      {/* <div className="d-flex mt-2">
                                                <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                    <span className="text-success fs-12 d-flex align-items-center me-1">
                                                        <i className="ti ti-arrow-wave-right-up me-1" />
                                                        +12.84%
                                                    </span>
                                                    from last month
                                                </p>
                                            </div> */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body ">
                      <div>
                        <div className="mb-2">
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            Pending Projects
                          </span>
                          <h5>{count ? count?.[0].pending_projects : 0}</h5>
                        </div>
                        <div
                          className="progress"
                          role="progressbar"
                          aria-label="Basic example"
                          aria-valuenow={count?.[0].pending_projects}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ width: "100%", height: 5 }}
                        >
                          <div
                            className="progress-bar bg-danger"
                            style={{ width: count?.[0].pending_projects }}
                          />
                        </div>
                      </div>
                      {/* <div className="d-flex mt-2">
                                                <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                    <span className="text-danger fs-12 d-flex align-items-center me-1">
                                                        <i className="ti ti-arrow-wave-right-up me-1" />
                                                        -10.75%
                                                    </span>
                                                    from last month
                                                </p>
                                            </div> */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body ">
                      <div>
                        <div className="mb-2">
                          <span className="fs-14 fw-normal text-truncate mb-1">
                            New Projects
                          </span>
                          <h5>
                            {count ? count?.[0].new_projects_this_month : 0}{" "}
                          </h5>
                        </div>
                        <div
                          className="progress"
                          role="progressbar"
                          aria-label="Basic example"
                          aria-valuenow={count?.[0].new_projects_this_month}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ width: "100%", height: 5 }}
                        >
                          <div
                            className="progress-bar bg-purple"
                            style={{
                              width: count?.[0].new_projects_this_month,
                            }}
                          />
                        </div>
                      </div>
                      {/* <div className="d-flex mt-2">
                                                <p className="fs-12 fw-normal d-flex align-items-center text-truncate">
                                                    <span className="text-success fs-12 d-flex align-items-center me-1">
                                                        <i className="ti ti-arrow-wave-right-up me-1" />
                                                        +15.74%
                                                    </span>
                                                    from last month
                                                </p>
                                            </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Exponses */}
            {/* Total Exponses */}
            <div className="col-lg-6 col-md-6 d-flex">
              <div className="card flex-fill">
                <div className="card-header border-0">
                  <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <div className="d-flex align-items-center ">
                      <span className="me-2">
                        <i className="ti ti-chart-pie text-danger" />
                      </span>
                      <h5>Projects By Tasks</h5>
                    </div>
                    {/* <div className="dropdown">
                                            <Link
                                                to="#"
                                                className="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                                                data-bs-toggle="dropdown"
                                            >
                                                Office Management App
                                            </Link>
                                            <ul className="dropdown-menu  dropdown-menu-end p-2">
                                                <li>
                                                    <Link
                                                        to="#"
                                                        className="dropdown-item rounded-1"
                                                    >
                                                        PRO-001
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link
                                                        to="#"
                                                        className="dropdown-item rounded-1"
                                                    >
                                                        PRO-002
                                                    </Link>
                                                </li>
                                                <li>
                                                    <Link
                                                        to="#"
                                                        className="dropdown-item rounded-1"
                                                    >
                                                        PRO-004
                                                    </Link>
                                                </li>
                                            </ul>
                                        </div> */}
                  </div>
                </div>
                <div className="card-body pt-0">
                  <div className="row align-items-center">
                    <div className="col-md-6 d-flex justify-content-center">
                      <ReactApexChart
                        key={projectchart.series.join("-")}
                        id="project-report"
                        options={projectchart}
                        series={projectchart.series}
                        type="pie"
                        height={246}
                      />
                    </div>
                    <div className="col-md-6">
                      <div className="row gy-4">
                        <div className="col-md-6">
                          <p className="fs-16 project-report-badge-blue fw-normal mb-0 text-gray-5">
                            Pending{" "}
                          </p>
                          <p className="fs-20 fw-bold text-dark ">
                            {getPercent(
                              count?.[0].pending_projects,
                              count?.[0].total_projects
                            )}
                            %
                          </p>
                        </div>
                        <div className="col-md-6">
                          <p className="fs-16 project-report-badge-purple mb-0  fw-normal text-gray-5">
                            On Hold
                          </p>
                          <p className="fs-20 fw-bold text-dark ">
                            {getPercent(
                              count?.[0].completed_projects,
                              count?.[0].total_projects
                            )}
                            %
                          </p>
                        </div>
                        <div className="col-md-6">
                          <p className="fs-16 project-report-badge-warning  mb-0 fw-normal text-gray-5">
                            Inprogress{" "}
                          </p>
                          <p className="fs-20 fw-bold text-dark ">
                            {getPercent(
                              count?.[0].inprogress_projects,
                              count?.[0].total_projects
                            )}
                          </p>
                        </div>
                        <div className="col-md-6">
                          <p className="fs-16 project-report-badge-success  mb-0 fw-normal text-gray-5">
                            Completed
                          </p>
                          <p className="fs-20 fw-bold text-dark ">
                            {getPercent(
                              count?.[0].completed_projects,
                              count?.[0].total_projects
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* /Total Exponses */}
          </div>
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Project List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3"></div>
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                      selectedStatus.slice(1)
                      : "Select Type"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("All")}
                        className="dropdown-item rounded-1"
                      >
                        All
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("Medium")}
                        className="dropdown-item rounded-1"
                      >
                        Medium
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("Low")}
                        className="dropdown-item rounded-1"
                      >
                        Low
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("High")}
                        className="dropdown-item rounded-1"
                      >
                        High
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filtereddata}
                columns={columns}
                Selection={false}
              />
            </div>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default ProjectReport;
